import { getPriceVisibility } from 'src/app/v1/dataAnalytics/utils/getPriceVisibility';
import type { Tealium } from 'src/types/appState';

import { EVENT_VIEW_CLASSIFY } from '../constants';

const getPurchaseType = (hirerType: string) =>
  hirerType.search('repeat') !== -1;

export const eventName = EVENT_VIEW_CLASSIFY;

export default (tealium: Tealium) => {
  const {
    addOnAdProductNames,
    emailAddressVerified,
    experiments,
    hubbleExperiments,
    hirerAdPurchaser,
    jobAdTypeSelected,
    previousPageName,
    priceVisibility,
    productPricing,
    productSetId,
  } = tealium;

  return {
    addOnAdProductNames,
    adProductSetId: productSetId,
    experiments,
    hubbleExperiments,
    isPriceHidden: getPriceVisibility(priceVisibility),
    isHirerRepeatAdPurchaser: getPurchaseType(hirerAdPurchaser),
    isEmailUnverified: !emailAddressVerified,
    isEcajaStart: !previousPageName,
    adProductName: [jobAdTypeSelected],
    adProductPricing: productPricing,
  };
};
